var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-blue-900 p-4 lg:p-12"},[_c('div',{staticClass:"max-w-7xl mx-auto"},[_c('div',{staticClass:"space-y-8"},[(_vm.$membershipHasPermissionTo('edit projects'))?_c('BaseButton',{attrs:{"tag":"router-link","to":{
          name: 'accounts.projects.project',
          params: {
            accountId: _vm.$route.params.accountId,
            projectId: _vm.$route.params.projectId,
          },
        },"primary":""}},[_vm._v(" Back to Project ")]):_vm._e(),_c('div',{staticClass:"space-y-1"},[_c('span',{staticClass:"inline-block text-sm text-blue-400"},[_vm._v(_vm._s(_vm.project.name))]),_c('h3',{staticClass:"text-xl text-white font-medium"},[_vm._v("Settings")])])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }